import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { IDayData, IStoreDataV3 } from '@df/catalog/store/store';
import { ISizeName } from '@df/core/service/client';
import { Url } from '@df/core/service/url';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import sortBy from 'lodash-es/sortBy';
import { LocalStore } from '../../../catalog/model/store/store.decorator';
import { StoreOpenStatusComponent } from '../../../catalog/ui/page/component/store-open-status/store-open-status.component';
import { IfTradeStoreDirective } from '../../../multisite/trade/if-trade-store.directive';
export const componentId = 'store-modal';
export namespace NStoreModal {
    export interface IOpeningDays {
        date: string;
        details: IDayData;
    }
    /**
     * Modal id
     */
    export const id = 'store-data';
    /**
     * Default setup for left side modal
     */
    export const ModalConfig: ModalConfig = {
        closeOnNavigation: true,
        minWidth: undefined,
        maxWidth: undefined,
        transformOptions: 'translate3d(-100%, 0px, 0px)',
        transitionOptions: '500ms ease-in-out',
        hasBackdrop: false,
        scrollStrategy: 'noop'
    };

    export interface IModalData {
        store: LocalStore<IStoreDataV3>;
        hideTags: boolean;
    }
}
@DfModal({
    id: NStoreModal.id,
    name: 'Store Data Popup',
    position: 'custom',
    config: (sizeId: ISizeName) => ({
        ...NStoreModal.ModalConfig,
        width: sizeId === 'S' || sizeId === 'M' ? '100vw' : '33vw',
        position: {
            left: '0'
        }
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X'])
})
@Component({
    selector: 'store-modal-component',
    templateUrl: './store-modal.html',
    styleUrls: ['./store-modal.scss'],
    standalone: true,
    imports: [
        DatePipe,
        HrefComponent,
        IfTradeStoreDirective,
        ImageModule,
        OptionImagePipe,
        OptionLabelPipe,
        StoreOpenStatusComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreModalComponent implements NDfModal.IModalComponent, OnInit {
    weeklySchedule: any;

    protected url = inject(Url);

    private data = inject(MODAL_DATA) as NStoreModal.IModalData;

    public store: LocalStore<IStoreDataV3> = this.data.store;
    public hideTags: boolean = this.data.hideTags;
    private modalRef = inject(ModalRef<StoreModalComponent>);

    /**
     * Modal option config
     */
    modalConfig?: NDfModal.IModalConfig;
    ngOnInit() {
        this.weeklySchedule = this.getWeeklySchedule();
    }
    /**
     * returns 7 upcoming store opening days with details
     */
    private getWeeklySchedule() {
        const openingHours = this.store.openingHours;
        let weeklySchedule: typeof this.store.openingHours = [];
        if (openingHours?.length) {
            /**
             * sorted last 7 days
             */
            weeklySchedule = sortBy(openingHours.slice(0, 7), (day: any) => day.date && day.date.getDay());
            /**
             * shifting sunday to the end of the week
             */
            const sunday = weeklySchedule.shift();
            if (sunday) {
                weeklySchedule.push(sunday);
            }
        }
        return weeklySchedule;
    }
    close() {
        this.modalRef.close();
    }

    protected getTagImage(tagIcon: string): string {
        return this.url.toMediaUrl(tagIcon);
    }
}
